import Swal from 'sweetalert2';
import {roundDecimals} from '../../../../../fromKotlin/nkutils';

/** «זכה סכום שנותר» above this asks first — it writes a credit note for the whole gap. */
export const LARGE_REFUND_ILS = 300;

/** The credit note «זכה סכום שנותר» writes: the marked documents less what is paid. */
export const refundRestAmount = (docs: { type: string; value_left: number }[], paid: number): number =>
    roundDecimals(
        docs.reduce((acc, p) => acc + (p.type === 'invoice' || p.type === 'sup_invoice' ? p.value_left : -p.value_left), 0) - paid,
        2,
    );

/** Asks before a large «זכה» credit note; true = go on. */
export const confirmLargeRefund = async (refund: number, color?: string): Promise<boolean> => {
    if (refund <= LARGE_REFUND_ILS) return true;
    const res = await Swal.fire({
        title: `תיווצר חשבונית זיכוי על ${refund.toLocaleString('he-IL', {maximumFractionDigits: 2})} ₪`,
        html: 'סימנת «זכה סכום שנותר»: החשבוניות שסימנת גדולות מהתשלום, וכל ההפרש ייסגר בחשבונית זיכוי ללקוח.<br/>'
            + 'אם סימנת חשבוניות שהלקוח לא משלם עליהן עכשיו — בטל את הסימון שלהן או את «זכה».',
        icon: 'warning',
        showCancelButton: true,
        ...(color ? {confirmButtonColor: color} : {}),
        confirmButtonText: 'כן, צור זיכוי והנפק',
        cancelButtonText: 'חזור לקבלה',
        reverseButtons: true,
    });
    return res.isConfirmed;
};
